import { cn } from 'utils/analytics/cn'

const VERSION_OPTIONS = [
  { value: 'v3', label: 'V3', alignment: 'text-left' as const },
  { value: 'v2', label: 'V2', alignment: 'text-right' as const },
] as const

type Version = (typeof VERSION_OPTIONS)[number]['value']

interface VersionSwitcherProps {
  selected: Version
  onSelect: (version: Version) => void
}

export default function VersionSwitcher({ selected, onSelect }: VersionSwitcherProps) {
  const handleSelect = (version: Version) => {
    if (version !== selected) {
      onSelect(version)
    }
  }

  return (
    <div
      className="flex gap-1 bg-kodiak-card-tertiary px-1 py-1 rounded-md"
      role="group"
      aria-label="Analytics version selector"
    >
      {VERSION_OPTIONS.map(({ value, label, alignment }) => {
        const isSelected = selected === value

        return (
          <button
            key={value}
            type="button"
            className={cn(
              'cursor-pointer px-3 py-1 rounded-sm transition-all duration-200 ease-in-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-kodiak-brand-primary',
              alignment,
              isSelected
                ? 'bg-kodiak-bg text-kodiak-brand-primary'
                : 'bg-transparent text-kodiak-text-quaternary hover:text-kodiak-text-primary'
            )}
            aria-pressed={isSelected}
            onClick={() => handleSelect(value)}
          >
            {label}
          </button>
        )
      })}
    </div>
  )
}
